export default defineNuxtPlugin({
  name: 'site',
  setup(nuxtApp) {
    const { sites, siteId, site } = useSite()

    if (import.meta.server) {
      const { context } = useRequestEvent()!
      sites.value = context.sites ?? []
      siteId.value = context.site?.siteId ?? null
    }

    if (!site.value) {
      throw createError({ statusCode: 404, statusMessage: 'Site not found', fatal: true })
    }

    nuxtApp.$i18n.locale.value = site.value.code
  },
})
